module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-xs-12 accessory-search-form"
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "form-control accessory-search-input",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "Search Accessory ID or Device ID...",
      "id": "search-plugin"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info btn-flat accessory-search-btn",
    on: {
      "click": _vm.toSearchPlugin
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDefault),
      expression: "isShowDefault"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-default-img",
    attrs: {
      "src": require("../../../static/img/icon_accessory_default.svg")
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowEmptyList),
      expression: "isShowEmptyList"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": require("../../../static/img/icon_no_matching_result.svg")
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._l((_vm.pluginList), function(item, index) {
    return _c('div', {
      staticClass: "accessory-list-overall"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }]
    }, [_c('div', {
      staticClass: "accessory-list-overall"
    }, [_c('div', {
      staticClass: "col-xs-12 accessory-list-header"
    }, [(!item[1][0].icon) ? _c('img', {
      staticClass: "accessory-list-type",
      attrs: {
        "src": require("../../../static/img/accessoryicon/icon_eventlist_others.svg")
      }
    }) : _c('img', {
      staticClass: "accessory-list-type",
      attrs: {
        "src": item[1][0].icon
      }
    }), _vm._v(" "), (!item[1][0].typeName) ? _c('span', {
      staticClass: "accessory-list-type-name"
    }, [_vm._v("Accessory")]) : _c('span', {
      staticClass: "accessory-list-type-name"
    }, [_vm._v(_vm._s(item[1][0].typeName))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right accessory-list-type-name"
    }, [_vm._v("\n                Accessory ID:  \n                "), _c('span', [_vm._v(_vm._s(item[0]))])])]), _vm._v(" "), _vm._l((item[1]), function(pluginItem, pIndex) {
      return _c('div', {
        staticClass: "col-xs-12 accessory-list-body"
      }, [_c('div', {
        staticClass: "accessory-list-rect row",
        attrs: {
          "data-toggle": "modal"
        },
        on: {
          "click": function($event) {
            _vm.toSetPlugin(index, pIndex)
          }
        }
      }, [_c('div', {
        staticClass: "col-xs-12 col-md-11 accessory-list-information"
      }, [_c('h5', [_vm._v("\n                    Accessory Name:  \n                    "), _c('span', [_vm._v(_vm._s(pluginItem.isprepluginname))])]), _vm._v(" "), _c('h5', [_vm._v("\n                    Binding Device:  \n                    "), _c('span', [_vm._v(_vm._s(pluginItem.devicename))]), _vm._v(" "), _c('span', {
        staticClass: "accessory-list-device-id"
      }, [_vm._v("\n                      (\n                      "), _c('span', [_vm._v(_vm._s(pluginItem.deviceid))]), _vm._v(" )\n                    ")])])]), _vm._v(" "), _vm._m(2, true)]), _vm._v(" "), _c('i', {
        staticClass: "fa fa-circle accessory-list-label"
      })])
    })], 2)])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "add-app-bgcolor dropup"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right add-btn-dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "add-agent-choose",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-add-offical-accessory"
    },
    on: {
      "click": _vm.toAddPlugin
    }
  }, [_vm._v("Add Offical Accessory")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "add-agent-choose",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-add-third-party-accessory"
    },
    on: {
      "click": _vm.toAddThirdPlugin
    }
  }, [_vm._v("Add Third Party Accessory")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-add-offical-accessory"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Accessory ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.pluginid),
      expression: "currentAddPlugin.pluginid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input Accessory ID"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.pluginid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "pluginid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.sub),
      expression: "currentAddPlugin.sub"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentAddPlugin, "sub", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0B"
    }
  }, [_vm._v("Door/Window Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("PIR Motion Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("Smoke Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("Vibration Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Emergency Button")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Remote Controller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("SmartPlugs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Wireless Sirens")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1B"
    }
  }, [_vm._v("SmartPad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0E"
    }
  }, [_vm._v("Water Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "37"
    }
  }, [_vm._v("Key Tag")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Binding Device ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.deviceid),
      expression: "currentAddPlugin.deviceid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input Device ID"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.deviceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "deviceid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.isPre),
      expression: "currentAddPlugin.isPre"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentAddPlugin, "isPre", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Pre-paired Accessory")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Non Pre-paired Accessory")])])])]), _vm._v(" "), (_vm.currentAddPlugin.isPre === 'true') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name control-label"
  }, [_vm._v("Production Batch")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.batch),
      expression: "currentAddPlugin.batch"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Text"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.batch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "batch", $event.target.value)
      }
    }
  })])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.pluginname),
      expression: "currentAddPlugin.pluginname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name the Accessory"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.pluginname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "pluginname", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSavePlugin
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-add-third-party-accessory"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Accessory ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.pluginid),
      expression: "currentAddPlugin.pluginid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input Accessory ID"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.pluginid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "pluginid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.sub),
      expression: "currentAddPlugin.sub"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentAddPlugin, "sub", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0B"
    }
  }, [_vm._v("Door/Window Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("PIR Motion Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("Smoke Sensor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Emergency Button")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Remote Controller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Wireless Sirens")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1B"
    }
  }, [_vm._v("SmartPad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0E"
    }
  }, [_vm._v("Water Sensor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Binding Device ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.deviceid),
      expression: "currentAddPlugin.deviceid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input Device ID"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.deviceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "deviceid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddPlugin.pluginname),
      expression: "currentAddPlugin.pluginname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name the Accessory"
    },
    domProps: {
      "value": (_vm.currentAddPlugin.pluginname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddPlugin, "pluginname", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveThirdPlugin
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-set-ipc"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(6), _vm._v(" "), (!_vm.currentPlugin.typeName) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Set Accessory")]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Set " + _vm._s(_vm.currentPlugin.typeName))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group modal-user-profile-head"
  }, [_vm._m(7), _vm._v(" "), (!_vm.currentPlugin.icon) ? _c('img', {
    staticClass: "modal-user-profile-img modal-user-profile-head-img",
    attrs: {
      "src": require("../../../static/img/accessoryicon/icon_eventlist_others.svg")
    }
  }) : _c('img', {
    staticClass: "modal-user-profile-img modal-user-profile-head-img",
    attrs: {
      "src": _vm.currentPlugin.icon
    }
  }), _vm._v(" "), _c('h5', [_vm._v("\n                Accessory ID:  \n                "), _c('span', [_vm._v(_vm._s(_vm.currentPlugin.pluginid))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group accessory-modal-set-binding-device"
  }, [_c('label', {
    staticClass: "col-sm-12 control-label agent-edit-modal-name"
  }, [_c('i', {
    staticClass: "fa fa-desktop accessory-modal-set-title-desktop"
  }), _vm._v("\n                Binding Device:  \n                "), _c('p', {
    staticClass: "accessory-modal-set-title-device set-accessory-dia-device-name",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.toSearchDevice(_vm.currentPlugin.devicename, _vm.currentPlugin.deviceid)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.currentPlugin.devicename) + "\n                  (\n                  "), _c('span', [_vm._v(_vm._s(_vm.currentPlugin.deviceid))]), _vm._v(")\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "accessory-modal-set-data-group"
  }, [_c('hr'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 accessory-modal-set-info"
  }, [_c('h5', [_c('label', [_vm._v("Binding Time:  ")]), _vm._v("\n                  " + _vm._s(_vm._f("formatDate")(_vm.currentPlugin.time / 1000000)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 accessory-modal-set-info"
  }, [_c('h5', {
    staticClass: "pull-right"
  }, [_c('label', [_vm._v("Type:")]), _vm._v("  \n                  "), (_vm.currentPlugin.isFactory) ? _c('span', [_vm._v("Pre-paired Accessory")]) : _c('span', [_vm._v("Non Pre-paired Accessory")]), _vm._v(" ; \n                  "), (_vm.currentPlugin.cat != 20) ? _c('span', [_vm._v("Offical Accessory")]) : _vm._e(), _vm._v(" "), (_vm.currentPlugin.cat == 20) ? _c('span', [_vm._v("Third Party Accessory")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name control-label"
  }, [_vm._v("Accessory Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [(!_vm.offlineClass) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPlugin.pluginname),
      expression: "currentPlugin.pluginname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.currentPlugin.pluginname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPlugin, "pluginname", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPlugin.pluginname),
      expression: "currentPlugin.pluginname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.currentPlugin.pluginname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPlugin, "pluginname", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "accessory-modal-set-data-group"
  }, [_c('hr'), _vm._v(" "), _c('h5', {
    staticClass: "accessory-modal-set-title"
  }, [_c('i', {
    staticClass: "fa fa-sliders accessory-modal-set-title-icon"
  }), _vm._v("\n                Setting\n                "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.offlineClass),
      expression: "!offlineClass"
    }],
    staticClass: "label accessory-modal-offline-lable"
  }, [_vm._v("Device Offline")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPlugin.typeName == 'Smart Plug'),
      expression: "currentPlugin.typeName == 'Smart Plug'"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-10 control-label agent-edit-modal-name"
  }, [_vm._v("Status:  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 modal-parameter-setting-switch"
  }, [(_vm.offlineClass == true) ? _c('input', {
    staticClass: "switch-checkbox pull-right",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  }) : _c('input', {
    staticClass: "switch-checkbox pull-right",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPlugin.typeName == 'Wireless Siren'),
      expression: "currentPlugin.typeName == 'Wireless Siren'"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Prompt Tone:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("\n                    Disarm\n                    "), (_vm.offlineClass == true) ? _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  }) : _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning",
      "disabled": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "pull-v"
  }, [_vm._v("\n                      Home Arm\n                      "), (_vm.offlineClass == true) ? _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  }) : _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                      Arm\n                      "), (_vm.offlineClass == true) ? _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning"
    }
  }) : _c('input', {
    staticClass: "switch-checkbox",
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "data-on-color": "info",
      "data-off-color": "warning",
      "disabled": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Light Mode:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Disarm\n                    "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                      Home Arm\n                      "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row accessory-modal-set-siren-row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Arm\n                    "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                      Alarm\n                      "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("OFF")]), _vm._v(" "), _c('option', [_vm._v("Always")]), _vm._v(" "), _c('option', [_vm._v("Twinkle")]), _vm._v(" "), _c('option', [_vm._v("Flash")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Volume:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Prompt Tone\n                    "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("0")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("0")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                      Alarm\n                      "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("0")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("0")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Siren Time (Min)")]), _vm._v(" "), (_vm.offlineClass == true) ? _c('select', {
    staticClass: "accessory-modal-set-selection"
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")])]) : _c('select', {
    staticClass: "accessory-modal-set-selection-offline",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer dropup"
  }, [(_vm.offlineClass == true) ? _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Unbind Device")]) : _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Unbind Device")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-left alert-del accessory-list-alert"
  }, [_vm._m(9), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.toUnbindPlugin
    }
  }, [_vm._v("Unbind")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toChangePluginName
    }
  }, [_vm._v("Save changes")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("Find your accessory and its binding device.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("Sorry, no matching results.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-chevron-right accessory-list-right-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "add-app-btn",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add Offical Accessory")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add Third Party Accessory")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-self-profile-upload-head modal-user-profile-head-input"
  }, [_c('input')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "accessory-modal-set-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o accessory-modal-set-title-icon"
  }), _vm._v("Information\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to unbind?\n            ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1742a186", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1742a186"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Accessory.vue
// module id = 459
// module chunks = 1